import _ from 'lodash';
import { Reducer } from 'redux';
import ContentConstants from '../contentConstants';
import { EmailTemplateType, IEmailTemplate } from '../models';
import { IEmail } from '../models/IEmail';
import { ISurveyBridge } from '../models/ISurveyBridge';
import * as EmailAPI from '../services/EmailAPI';
import * as EmailTemplateAPI from '../services/EmailTemplateAPI';
import * as SurveyAPI from '../services/SurveyAPI';
import {
	IGetEmailTemplateSucceeded,
	IGetPreviewUrlSucceeded,
	ISendEmailFailed,
	ISendEmailRequested,
	ISendEmailSuccess,
	IToggleSendEmailModal,
} from './Actions';
import { ActionTypes } from './ActionTypes';

export interface IEmailState {
	isSendingEmail: boolean;
	massMailJobId: string;
	sendEmailModalOpen: boolean;
	previewUrl: string;
	invitationEmailTemplate?: IEmailTemplate;
}

export const defaultState: IEmailState = {
	isSendingEmail: false,
	massMailJobId: '',
	sendEmailModalOpen: false,
	previewUrl: '',
};

export const ActionCreators = {
	SendEmail: (emailTemplate: IEmail) => (dispatch: any) => {
		dispatch({ type: ActionTypes.SEND_EMAIL_REQUESTED });

		return EmailAPI.sendEmail(emailTemplate)
			.then((jobId: string) => {
				dispatch({ type: ActionTypes.SEND_EMAIL_SUCCEEDED, payload: { jobId } });

				dispatch({ type: ActionTypes.TOAST_SUCCESS_NOTIFICATION, payload: ContentConstants.TOAST_SEND_TEST_EMAIL_SUCCESS });
			})
			.catch(() => {
				dispatch({ type: ActionTypes.SEND_EMAIL_FAILED });
				dispatch({ type: ActionTypes.TOAST_WARNING_GENERIC_NOTIFICATION });
			});
	},
	ToggleSendEmailModal: (isOpen: boolean) => (dispatch: any) => {
		dispatch({ type: ActionTypes.TOGGLE_SEND_EMAIL_MODAL, payload: isOpen });
	},
	GetPreviewUrl: (surveyId: number) => (dispatch: any) => {
		dispatch({ type: ActionTypes.GET_PREVIEW_URL_REQUESTED });

		return SurveyAPI.getSurveyBridge(surveyId)
			.then((bridge: ISurveyBridge) => {
				dispatch({ type: ActionTypes.GET_PREVIEW_URL_SUCCEEDED, payload: bridge.previewUrl });
			})
			.catch(() => {
				dispatch({ type: ActionTypes.GET_PREVIEW_URL_FAILED });
				dispatch({ type: ActionTypes.TOAST_WARNING_GENERIC_NOTIFICATION });
			});
	},
	GetEmailTemplate: (surveyId: number, audienceId: number) => (dispatch: any) => {
		dispatch({ type: ActionTypes.GET_EMAIL_TEMPLATE_REQUESTED });

		return EmailTemplateAPI.getEmailTemplates(surveyId, audienceId, EmailTemplateType.Invitation)
			.then((templates: IEmailTemplate[]) => {
				dispatch({ type: ActionTypes.GET_EMAIL_TEMPLATE_SUCCEEDED, payload: templates[0] });
			})
			.catch(() => {
				dispatch({ type: ActionTypes.GET_EMAIL_TEMPLATE_FAILED });
				dispatch({ type: ActionTypes.TOAST_WARNING_GENERIC_NOTIFICATION });
			});
	},
};

type KnownActions =
	| ISendEmailRequested
	| ISendEmailSuccess
	| ISendEmailFailed
	| IToggleSendEmailModal
	| IGetPreviewUrlSucceeded
	| IGetEmailTemplateSucceeded;

export const reducer: Reducer<IEmailState, KnownActions> = (state: IEmailState = defaultState, action: KnownActions) => {
	switch (action.type) {
		case ActionTypes.SEND_EMAIL_REQUESTED:
			return { ...state, massMailJobId: '', isSendingEmail: true };
		case ActionTypes.SEND_EMAIL_SUCCEEDED:
			return { ...state, massMailJobId: action.payload.jobId, sendEmailModalOpen: false, isSendingEmail: false };
		case ActionTypes.SEND_EMAIL_FAILED:
			return { ...state, massMailJobId: '', sendEmailModalOpen: true, isSendingEmail: false };
		case ActionTypes.TOGGLE_SEND_EMAIL_MODAL:
			return { ...state, sendEmailModalOpen: action.payload };
		case ActionTypes.GET_PREVIEW_URL_SUCCEEDED:
			return { ...state, previewUrl: action.payload };
		case ActionTypes.GET_EMAIL_TEMPLATE_SUCCEEDED:
			return { ...state, invitationEmailTemplate: action.payload };
		default:
			return { ...state };
	}
};
